/**
 * The scaling step: a list grows or shrinks. Emerald, so it reads apart
 * from the terrible-list rule.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { TrendingUp } from 'lucide-react';

import { StepCard, Switch } from '@/components/ui';

import type { DropGenPlanDetail } from '../../../../drop-generator.types';
import { InheritedSection } from '../../master/InheritedSection';
import { useSectionSources } from '../../master/section-sources';
import type { ContainerEditor } from '../../state/useContainerEditor';
import { ScalingStep } from '../scaling/ScalingStep';
import { scalingSummary } from '../scaling/scaling-summary';

interface Props {
  index: number;
  editor: ContainerEditor;
  plan: DropGenPlanDetail;
  containerId: string | null;
}

export const ScalingCard: FC<Props> = ({ index, editor, plan, containerId }) => {
  const own = useSectionSources().isOwn('verdict');
  return (
    <StepCard
      index={index}
      tone="emerald"
      icon={TrendingUp}
      title="Scaling"
      summary={scalingSummary(editor.draft)}
      headerRight={
        <Switch
          checked={editor.draft.scalingEnabled}
          disabled={!own}
          onCheckedChange={(enabled) => editor.setField('scalingEnabled', enabled)}
          aria-label="Enable scaling"
        />
      }
    >
      <InheritedSection section="verdict">
        <ScalingStep editor={editor} plan={plan} containerId={containerId} />
      </InheritedSection>
    </StepCard>
  );
};
